const fieldNames = {
  IFRAME_EMBEDDING_TYPE: 'iframe-embedding-type',
  IFRAME_URL: 'iframeUrl',
  IFRAME_ALLOW_FULLSCREEN: 'iframeAllowFullscreen',
  IFRAME_CODE: 'iframeCode',
};

export default fieldNames;
